<template>
  <div class="main">
    <div class="setting flex-row jc-start" style="margin-bottom:10px">
      <el-button :icon="settingType ? 'el-icon-edit' : 'el-icon-view'" size="medium" :type="settingType ? 'warning' :''"  @click="handSetting">{{ settingType ? '编辑' : '确定' }} </el-button>
    </div>
    <el-row >
    <!-- <div class="tabs">
      <el-tabs v-model="activeName">
        <el-tab-pane label="English" name="en"></el-tab-pane>
        <el-tab-pane label="中文" name="cn"></el-tab-pane>
      </el-tabs>
    </div> -->
    <div class="homeLayout">
      <!-- 标题内容 -->
      <div class="layout_bg bordersolid">
        <el-col :span="24" class="pl16 pr16">
          <el-divider content-position="left">标题内容</el-divider>
        </el-col>
        <!-- <div>
          <el-input v-if="activeName == 'en'" v-model="aboutUsTitle.valEn" :disabled="settingType" class="inputWidth" @change="changeInput($event,aboutUsTitle)"></el-input>
          <el-input v-else v-model="aboutUsTitle.valCn" :disabled="settingType" class="inputWidth" @change="changeInput($event,aboutUsTitle)"></el-input>
        </div> -->
        <!-- <div class="pd16"> -->
          <el-row :gutter="15" class="mg16">
            <el-col :span="12">
              <!-- <div> -->
              <!-- <div style="width: 120px;">内文（英）：</div> -->
                <el-input type="textarea" rows="5"  v-model="aboutUsContent.valEn" :disabled="settingType"  class="" @change="changeInput($event,aboutUsContent)"></el-input>
              <!-- </div> -->
            </el-col>
            <el-col :span="12">
              <!-- <span style="width: 120px;">内文（中）：</span> -->
              <el-input type="textarea" rows="5"  v-model="aboutUsContent.valCn" :disabled="settingType"  class=" ml16" @change="changeInput($event,aboutUsContent)"></el-input>
            </el-col>
          </el-row>
        <!-- </div> -->
      </div>
      <!-- 四大模块 -->
      <!-- <div class="layout_aboutUs bordersolid mt4">
        <div class="pd16">
          <el-divider content-position="left">四大模块</el-divider>
        </div>
          <div class="flex-row jc-evenly pd16">
            <el-row >
              <el-col :span="12" v-for="bitem in aboutUsList" :key="bitem.id">
                <div class="ta-center pd8" >
                  <div v-for="bcitem in bitem" :key="bcitem.id">
                    <image-upload-new v-if="bcitem.type == 'image'" v-model="bcitem.pic" :disabled="settingType" :limit="1" tip="单个图片不要超过10M" class="mb8" @updateChange="changeImage($event,bcitem)"></image-upload-new>
                    <div v-else-if="bcitem.type == 'title'">
                      <el-row :gutter="15">
                        <el-col :span="12">
                          <el-input v-model="bcitem.valEn"  :disabled="settingType" class="" @change="changeInput($event,bcitem)"></el-input>
                        </el-col>
                        <el-col :span="12">
                          <el-input v-model="bcitem.valCn"  :disabled="settingType" class="" @change="changeInput($event,bcitem)"></el-input>
                        </el-col>
                      </el-row>
                    </div>
                    <div class="mt8" v-else>
                      <el-row :gutter="15">
                        <el-col :span="12">
                          <el-input type="textarea" rows="5" v-model="bcitem.valEn"  :disabled="settingType" class="" @change="changeInput($event,bcitem)"></el-input>
                        </el-col>
                        <el-col :span="12">
                          <el-input type="textarea" rows="5" v-model="bcitem.valCn"  :disabled="settingType" class="" @change="changeInput($event,bcitem)"></el-input>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
      </div> -->
      <div class="bordersolid mt4">
        <el-row class="pd16">
          <el-col :span="24" class="">
            <el-divider content-position="left">视频</el-divider>
          </el-col>
          <el-col :span="24">
            <CropperView :imgSrc="vidoForm.pic" :disabled="settingType"  :actionButtonFlag="true" :objectFit="'cover'" :listIndex="1" :maxVideoSize="uploadVideoSize" @updateChange="changeImage2($event,vidoForm)"></CropperView>
          </el-col>
        </el-row>
      </div>
      <div class="bordersolid mt4">
        <el-row class="pd16">
        <el-col :span="24" class="">
          <el-divider content-position="left">展厅</el-divider>
        </el-col>
        <!-- <el-col :span="24" :class="inputForm.showGallery == '0' ? 'opacity5' : ''">
            <el-form-item label="是否在详情显示" prop="showGallery">
                  <el-radio-group v-model="inputForm.showGallery">
                    <el-radio :label="item.value" v-for="item in $dictUtils.getDictList('yes_no')" :key="item.id">{{ item.label }}</el-radio>
                  </el-radio-group>
           </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-input v-model="galleryTitle.valEn"  :disabled="settingType" placeholder="请输入标题" class="" @change="changeInput($event,galleryTitle)"></el-input>
        </el-col>
        <el-col :span="12">
          <el-input v-model="galleryTitle.valCn"  :disabled="settingType" placeholder="请输入标题" class="ml16" @change="changeInput($event,galleryTitle)"></el-input>
        </el-col>

        <el-col :span="12">
          <el-input type="textarea" rows="5" v-model="galleryContent.valEn" placeholder="请输入内容"  :disabled="settingType" class="mt16" @change="changeInput($event,galleryContent)"></el-input>
        </el-col>
        <el-col :span="12">
          <el-input type="textarea" rows="5" v-model="galleryContent.valCn" placeholder="请输入内容"  :disabled="settingType" class="ml16 mt16" @change="changeInput($event,galleryContent)"></el-input>
        </el-col>
        <el-col :span="24" class="mt16">
            <!-- <el-form-item label="展览集" prop="gallery"
                :rules="[
                  {required: true  , message:'展览集不能为空', trigger:'change'}
                 ]"> -->
                 <ImageUploadDraggableBtn 
                 key="galleryForm"
                 v-model="galleryForm.gallery" 
                 :draggable="true" 
                 :itemActivityForm="true"
                 :ifSetUploadName="true" 
                 :ownerId="galleryForm.id" 
                 :uploadInfo="{type:'gallery',title:'展览集',category: 'about',categoryName: '关于我们',tip:'请先输入英文名称',fileName: 'about' }" 
                 :disabled="settingType"  
                 :otherPrams="otherPrams" 
                 action="/unmfile/cecUnmFileupload"  
                 tip="单个图片不要超过10M,可拖动列表行排序"
                 @updateDet="doSubmit()"
                 @updateChange="handImageList($event,'galleryForm')">
                 </ImageUploadDraggableBtn>
           <!-- </el-form-item> -->
        </el-col>
        </el-row>
      </div>
      <div class="bordersolid mt4">
        <el-row class="pd16">
          <el-col :span="24" class="">
            <el-divider content-position="left">办公室</el-divider>
          </el-col>
          <!-- <el-col :span="24" :class="inputForm.showGallery == '0' ? 'opacity5' : ''">
              <el-form-item label="是否在详情显示" prop="showGallery">
                    <el-radio-group v-model="inputForm.showGallery">
                      <el-radio :label="item.value" v-for="item in $dictUtils.getDictList('yes_no')" :key="item.id">{{ item.label }}</el-radio>
                    </el-radio-group>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-input v-model="galleryOfficeTitle.valEn"  :disabled="settingType" placeholder="请输入标题" class="" @change="changeInput($event,galleryOfficeTitle)"></el-input>
          </el-col>
          <el-col :span="12">
            <el-input v-model="galleryOfficeTitle.valCn"  :disabled="settingType" placeholder="请输入标题" class="ml16" @change="changeInput($event,galleryOfficeTitle)"></el-input>
          </el-col>

          <el-col :span="12">
            <el-input type="textarea" rows="5" v-model="galleryOfficeContent.valEn" placeholder="请输入内容"  :disabled="settingType" class="mt16" @change="changeInput($event,galleryOfficeContent)"></el-input>
          </el-col>
          <el-col :span="12">
            <el-input type="textarea" rows="5" v-model="galleryOfficeContent.valCn" placeholder="请输入内容"  :disabled="settingType" class="ml16 mt16" @change="changeInput($event,galleryOfficeContent)"></el-input>
          </el-col>
          <el-col :span="24" class="mt16">
              <!-- <el-form-item label="展览集" prop="gallery"
                  :rules="[
                    {required: true  , message:'展览集不能为空', trigger:'change'}
                  ]"> -->
                  <ImageUploadDraggableBtn 
                  key="galleryOfficeForm"
                  v-model="galleryOfficeForm.gallery" 
                  :draggable="true" 
                  :itemActivityForm="true"
                  :ifSetUploadName="true" 
                  :ownerId="galleryOfficeForm.id" 
                  :uploadInfo="{type:'gallery',title:'展览集-办公室',category: 'about',categoryName: '关于我们',tip:'请先输入英文名称',fileName: 'about' }" 
                  :disabled="settingType"  
                  :otherPrams="otherPrams" 
                  action="/unmfile/cecUnmFileupload"  
                  tip="单个图片不要超过10M,可拖动列表行排序"
                  @updateDet="doSubmit()"
                  @updateChange="handImageList($event,'galleryOfficeForm')">
                  </ImageUploadDraggableBtn>
            <!-- </el-form-item> -->
          </el-col>
        </el-row>
      </div>
      <div class="bordersolid mt4">
        <el-row class="pd16">
          <el-col :span="24" class="">
            <el-divider content-position="left">仓库</el-divider>
          </el-col>
          <!-- <el-col :span="24" :class="inputForm.showGallery == '0' ? 'opacity5' : ''">
              <el-form-item label="是否在详情显示" prop="showGallery">
                    <el-radio-group v-model="inputForm.showGallery">
                      <el-radio :label="item.value" v-for="item in $dictUtils.getDictList('yes_no')" :key="item.id">{{ item.label }}</el-radio>
                    </el-radio-group>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-input v-model="galleryWarehouseTitle.valEn"  :disabled="settingType" placeholder="请输入标题" class="" @change="changeInput($event,galleryWarehouseTitle)"></el-input>
          </el-col>
          <el-col :span="12">
            <el-input v-model="galleryWarehouseTitle.valCn"  :disabled="settingType" placeholder="请输入标题" class="ml16" @change="changeInput($event,galleryWarehouseTitle)"></el-input>
          </el-col>

          <el-col :span="12">
            <el-input type="textarea" rows="5" v-model="galleryWarehouseContent.valEn" placeholder="请输入内容"  :disabled="settingType" class="mt16" @change="changeInput($event,galleryWarehouseContent)"></el-input>
          </el-col>
          <el-col :span="12">
            <el-input type="textarea" rows="5" v-model="galleryWarehouseContent.valCn" placeholder="请输入内容"  :disabled="settingType" class="ml16 mt16" @change="changeInput($event,galleryWarehouseContent)"></el-input>
          </el-col>
          <el-col :span="24" class="mt16">
              <!-- <el-form-item label="展览集" prop="gallery"
                  :rules="[
                    {required: true  , message:'展览集不能为空', trigger:'change'}
                  ]"> -->
                  <ImageUploadDraggableBtn 
                  key="galleryWarehouseForm"
                  v-model="galleryWarehouseForm.gallery" 
                  :draggable="true" 
                  :itemActivityForm="true"
                  :ifSetUploadName="true" 
                  :ownerId="galleryWarehouseForm.id" 
                  :uploadInfo="{type:'gallery',title:'展览集-仓库',category: 'about',categoryName: '关于我们',tip:'请先输入英文名称',fileName: 'about' }" 
                  :disabled="settingType"  
                  :otherPrams="otherPrams" 
                  action="/unmfile/cecUnmFileupload"  
                  tip="单个图片不要超过10M,可拖动列表行排序"
                  @updateDet="doSubmit()"
                  @updateChange="handImageList($event,'galleryWarehouseForm')">
                  </ImageUploadDraggableBtn>
            <!-- </el-form-item> -->
          </el-col>
        </el-row>
      </div>
      <div class=" bordersolid mt4 pd16">
        <div class="">
          <el-divider content-position="left">合作伙伴</el-divider>
        </div>
        <!-- <el-col :span="24" class=""> -->
          <div class="flex-row ai-center jc-evenly">
            <div>
              <div>
                <el-row :gutter="15">
                  <el-col :span="12">
                    <el-input type="textarea" rows="5"  v-model="aboutUsCpTitle.valEn" :disabled="settingType"  class="inputWidth" @change="changeInput($event,aboutUsCpTitle)"></el-input>
                  </el-col>
                  <el-col :span="12">
                    <el-input type="textarea" rows="5"  v-model="aboutUsCpTitle.valCn" :disabled="settingType"  class="inputWidth" @change="changeInput($event,aboutUsCpTitle)"></el-input>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div>
              <image-upload-new v-model="aboutUsCpImageTop.pic" :disabled="settingType" :limit="3" tip="单个图片不要超过10M" class="mb8" @updateChange="changeImage($event,aboutUsCpImageTop)"></image-upload-new>
              <image-upload-new v-model="aboutUsCpImageBottom.pic" :disabled="settingType" :limit="3" tip="单个图片不要超过10M" class="mb8" @updateChange="changeImage($event,aboutUsCpImageBottom)"></image-upload-new>
            </div>
          </div>
        <!-- </el-col> -->
      </div>
    </div>
    </el-row>
  </div>
</template>
<script>
import ImageUploadNew from '@/components/upload/ImageUploadNoAddIon'
import CropperView from '@/components/upload/ImageUploadCropper.vue'
import ImageUploadDraggableBtn from '@/components/upload/ImageUploadDraggableBtn'
import cecAboutService from '@/api/about/cecAboutService'
import llFilter from '@/utils/listLayoutFilter.js'
import _ from 'lodash'
export default {
  data () {
    return {
      inputForm: {
        pic: '',
        valEn: '',
        valCn: ''
      },
      galleryForm: {
        gallery: [],
        id: ''
      },
      galleryTitle: {},
      galleryContent: {},

      galleryOfficeForm: {
        gallery: [],
        id: ''
      },
      galleryOfficeTitle: {},
      galleryOfficeContent: {},

      galleryWarehouseForm: {
        gallery: [],
        id: ''
      },
      galleryWarehouseTitle: {},
      galleryWarehouseContent: {},
      vidoForm: {
        pic: '',
        id: ''
      },
      otherPrams: {
        id: '',
        type: 'about'
      },
      settingType: true,
      activeName: 'en',
      dataList: [],
      aboutUsTitle: {},
      aboutUsContent: {},
      aboutUsList: [],
      aboutUsCpTitle: {},
      aboutUsCpImageTop: {},
      aboutUsCpImageBottom: {},
      uploadVideoSize: 200
    }
  },
  components: {
    ImageUploadNew,
    ImageUploadDraggableBtn,
    CropperView
  },
  activated () {
    this.refreshList()
    let uploadSize = localStorage.getItem('uploadVideoSize')
    this.uploadVideoSize = Number(uploadSize)
  },
  methods: {
    //  upload image 上传图片
    changeImage2 (e, item) {
      if (e) {
        item.pic = typeof e === 'string' ? e : e.filePath
        this.saveData(item, 'refresh')
      } else {
        item.pic = ''
        this.saveData(item, 'refresh')
      }
    },
    // 上传返回ids
    handImageList: _.debounce(function (e, type, uploadType) {
      const that = this
      let mapList = uploadType === 'cropper' ? [e] : e
      that[type].gallery = mapList.map(item => {
        let ritem = {
          id: item.percentage === 0 ? '' : item.id,
          fileName: item.fileName,
          fileSize: item.size ? item.size : item.fileSize,
          url: item.url,
          filePath: item.filePath ? item.filePath : item.url,
          category: item.category ? item.category : 'about_gallery',
          description: item.description ? item.description : '',
          actorId: item.actorId,
          actorName: item.actorName,
          categoryName: item.categoryName,
          startTime: item.startTime,
          createDate: item.createDate,
          pixel: item.pixel,
          name: item.name
        }
        return ritem
      })
      this.saveData(that[type], 'refresh')
    }, 500),
    // 表单提交
    doSubmit: _.debounce(function () {
      console.log('111111111111111')
    }, 100),
    handSetting () {
      this.settingType = !this.settingType
    },
    // 获取数据列表
    refreshList: _.debounce(function () {
      this.dataList = []
      this.aboutUsList = []
      this.aboutUsBasicsList = []
      this.howWorksStepList = []
      this.ourfiveServiceList = []
      this.slideshowRightList = []
      cecAboutService.list({
        'current': '1',
        'size': '1000',
        'orders': {column: 'create_data', asc: false}
      }).then(({data}) => {
        this.dataList = data.records
        this.galleryForm = llFilter.findData(data.records, 'about-cp-gallery-image')
        this.galleryTitle = llFilter.findData(data.records, 'about-cp-gallery-image-title')
        this.galleryContent = llFilter.findData(data.records, 'about-cp-gallery-image-content')

        this.galleryOfficeForm = llFilter.findData(data.records, 'about-cp-gallery-image-office')
        this.galleryOfficeTitle = llFilter.findData(data.records, 'about-cp-gallery-image-office-title')
        this.galleryOfficeContent = llFilter.findData(data.records, 'about-cp-gallery-image-office-content')

        this.galleryWarehouseForm = llFilter.findData(data.records, 'about-cp-gallery-image-warehouse')
        this.galleryWarehouseTitle = llFilter.findData(data.records, 'about-cp-gallery-image-warehouse-title')
        this.galleryWarehouseContent = llFilter.findData(data.records, 'about-cp-gallery-image-warehouse-content')

        this.vidoForm = llFilter.findData(data.records, 'about-cp-video')
        this.aboutUsTitle = llFilter.findData(data.records, 'about-title')
        this.aboutUsContent = llFilter.findData(data.records, 'about-content')
        this.aboutUsList.push(llFilter.filterData(data.records, 'about-fourmodules-qualification', ['image', 'title', 'content']))
        this.aboutUsList.push(llFilter.filterData(data.records, 'about-fourmodules-system', ['image', 'title', 'content']))
        this.aboutUsList.push(llFilter.filterData(data.records, 'about-fourmodules-supply', ['image', 'title', 'content']))
        this.aboutUsList.push(llFilter.filterData(data.records, 'about-fourmodules-quality', ['image', 'title', 'content']))
        this.aboutUsCpTitle = llFilter.findData(data.records, 'about-cp-title')
        this.aboutUsCpImageTop = llFilter.findData(data.records, 'about-cp-image-top')
        this.aboutUsCpImageBottom = llFilter.findData(data.records, 'about-cp-image-bottom')
      })
    }, 2000),
    //  upload image 上传图片
    changeImage (e, item) {
      if (e) {
        this.saveData(item)
      }
    },
    // input修改事件
    changeInput (e, item) {
      if (e) {
        this.saveData(item)
      } else {
        this.$message.error('不能设置为空')
      }
    },
    // 更新数据
    saveData (inputForm, type) {
      cecAboutService.save(inputForm).then(({data}) => {
        this.$message.success('设置成功')
        if (type === 'refresh') {
          this.refreshList()
        }
      }).catch(() => {
        this.$message.error('设置失败')
      })
    }
  }
}
</script>
<style scoped lang="less">
.main {
  padding: 10px;
  height: 100%;
  background-color: #fff;
  overflow-y: auto;
  .homeLayout {
    .layout_bg {
      // display: flex;
      // flex-wrap: wrap;
      // align-items: center;
      // justify-content: center;
      //  padding-top: 20px;
      // div {
      //   margin-bottom: 10px;
      //   display: block;
      //   display: flex;
      //   // justify-content: center;
      //   width: 100%;
      // }
    }
    .layout_aboutUs{
    }
  }
}
.inputWidth{
  width: 300px !important;
}
.el-input{
  display: block;
}
.bordersolid{
  border: 1px solid rgba(112, 110, 110, 0.596);
}
.ta-center{
  text-align: center;
}
::v-deep .el-tabs__item{
  padding: 0 20px !important;
}
.ml16{
  margin-left: 16px;
}
.pd8{ 
  padding: 8px;
}
.mt8 {
  margin-top: 9px;
}
</style>
